<template>
  <div>
    <div ref="goalsMenu" :open="true" as="div" class="relative flex-shrink-0 ml-auto">
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <div
          static
          :class="[
            { 'ml-8 mt-8': position == 'b' },
            { 'ml-8 -mt-8': position == 't' },
            { 'ml-0 mt-0': position == 'l' },
            { 'ml-16  mt-0': position == 'r' }
          ]"
          class="absolute z-50 ml-10 origin-bottom-right bg-white border rounded-md w-52 border-light-divider focus:outline-none">
          <div v-for="item in items_filtered" :key="item.name" as="div">
            <button
              :class="[
                'hover:bg-gray-50  hover:text-light-body-text  w-full group sm:text-sm flex items-center px-4 py-4 disabled:bg-common-disable-bg disabled:cursor-default disabled:opacity-60  transition ease-in-out duration-side-menu-transition-duration'
              ]"
              @click="handleSelectItem(item)">
              <Menu v-if="item.options?.length" ref="goalsMenu" as="div" class="relative flex-shrink-0">
                <MenuButton class="relative flex items-center w-52">
                  <div :style="{ background: item.icon_bg_color }" class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                    <component
                      :is="item.icon"
                      v-if="item.icon"
                      :class="['text-light-grey dark:text-common-grey ']"
                      :style="{ color: item.icon_color }"
                      class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                      aria-hidden="true" />
                  </div>
                  <div>
                    {{ item.name }}
                    <span class="absolute right-10">
                      <ChevronRight class="w-4 h-4" />
                    </span>
                  </div>
                </MenuButton>

                <transition
                  enter-active-class="transition duration-100 ease-out"
                  enter-from-class="transform scale-95 opacity-0"
                  enter-to-class="transform scale-100 opacity-100"
                  leave-active-class="transition duration-75 ease-in"
                  leave-from-class="transform scale-100 opacity-100"
                  leave-to-class="transform scale-95 opacity-0">
                  <MenuItems
                    class="absolute z-50 ml-48 -mt-10 origin-bottom-right bg-white border rounded-md w-52 border-light-divider focus:outline-none">
                    <div v-if="item.value !== 'extractor'" class="flex w-[90%] mx-2 rounded-md shadow-sm m-2 mt-4">
                      <div class="relative flex items-stretch flex-grow focus-within:z-10">
                        <div class="absolute inset-y-0 left-0 z-50 flex items-center pl-3 pointer-events-none">
                          <Search class="w-5 h-5 text-gray-400" />
                        </div>
                        <TextInput
                          :icon="true"
                          :value="search_term"
                          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                          name="trigger"
                          type="text"
                          :validate-on-input="true"
                          :label="$t('Search')"
                          @update:modelValue="
                            (e) => {
                              search_term = e
                            }
                          " />
                      </div>
                    </div>

                    <div
                      v-for="option in item.options.filter((option) => option?.name?.toLowerCase().includes(search_term?.toLowerCase()))"
                      :key="option.name"
                      as="div">
                      <Menu v-if="option.options?.length" ref="goalsMenu" as="div" class="relative flex-shrink-0">
                        <MenuButton class="relative flex items-center py-4 w-52">
                          <div
                            :style="{ background: option.icon_bg_color }"
                            class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                            <component
                              :is="option.icon"
                              v-if="option.icon"
                              :class="['text-light-grey dark:text-common-grey']"
                              class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                              aria-hidden="true" />
                          </div>
                          <div>
                            {{ option.name }}
                            <span class="absolute right-10">
                              <ChevronRight class="w-4 h-4" />
                            </span>
                          </div>
                        </MenuButton>

                        <transition
                          enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-in"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                          <MenuItems
                            class="absolute z-50 ml-48 -mt-10 origin-bottom-right bg-white border rounded-md w-52 border-light-divider focus:outline-none">
                            <div
                              v-for="option in option.options.filter((option) =>
                                option?.name?.toLowerCase().includes(search_term?.toLowerCase())
                              )"
                              :key="option.name"
                              as="div">
                              <Menu v-if="option.options?.length" ref="goalsMenu" as="div" class="relative flex-shrink-0">
                                <MenuButton class="relative flex items-center py-4 w-52">
                                  <div
                                    :style="{ background: option.icon_bg_color }"
                                    class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                                    <component
                                      :is="option.icon"
                                      v-if="option.icon"
                                      :class="['text-light-grey dark:text-common-grey']"
                                      class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                                      aria-hidden="true" />
                                  </div>
                                  <div>
                                    {{ option.name }}
                                    <span class="absolute right-10">
                                      <ChevronRight class="w-4 h-4" />
                                    </span>
                                  </div>
                                </MenuButton>

                                <transition
                                  enter-active-class="transition duration-100 ease-out"
                                  enter-from-class="transform scale-95 opacity-0"
                                  enter-to-class="transform scale-100 opacity-100"
                                  leave-active-class="transition duration-75 ease-in"
                                  leave-from-class="transform scale-100 opacity-100"
                                  leave-to-class="transform scale-95 opacity-0">
                                  <MenuItems
                                    class="absolute z-50 ml-48 -mt-10 origin-bottom-right bg-white border rounded-md w-52 border-light-divider focus:outline-none">
                                    <div
                                      v-for="option in option.options.filter((option) =>
                                        option?.name?.toLowerCase().includes(search_term?.toLowerCase())
                                      )"
                                      :key="option.name"
                                      as="div">
                                      <button
                                        :class="[
                                          'hover:bg-gray-50  hover:text-light-body-text  w-full group sm:text-sm flex items-center px-4 py-4 disabled:bg-common-disable-bg disabled:cursor-default disabled:opacity-60  transition ease-in-out duration-side-menu-transition-duration'
                                        ]"
                                        @click="handleSelectSubItem(item, option)">
                                        <div
                                          :style="{ background: option.icon_bg_color }"
                                          class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                                          <component
                                            :is="option.icon"
                                            v-if="option.icon"
                                            :class="['text-light-grey dark:text-common-grey']"
                                            class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                                            aria-hidden="true" />
                                        </div>
                                        <div>
                                          {{ option.name }}
                                        </div>
                                      </button>
                                    </div>
                                  </MenuItems>
                                </transition>
                              </Menu>

                              <button
                                v-else
                                :class="[
                                  'hover:bg-gray-50  hover:text-light-body-text  w-full group sm:text-sm flex items-center px-4 py-4 disabled:bg-common-disable-bg disabled:cursor-default disabled:opacity-60  transition ease-in-out duration-side-menu-transition-duration'
                                ]"
                                @click="handleSelectSubItem(item, option)">
                                <div
                                  :style="{ background: option.icon_bg_color }"
                                  class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                                  <component
                                    :is="option.icon"
                                    v-if="option.icon"
                                    :class="['text-light-grey dark:text-common-grey']"
                                    class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                                    aria-hidden="true" />
                                </div>
                                <div>
                                  {{ option.name }}
                                </div>
                              </button>
                            </div>
                          </MenuItems>
                        </transition>
                      </Menu>

                      <button
                        v-else
                        :class="[
                          'hover:bg-gray-50  hover:text-light-body-text  w-full group sm:text-sm flex items-center px-4 py-4 disabled:bg-common-disable-bg disabled:cursor-default disabled:opacity-60  transition ease-in-out duration-side-menu-transition-duration'
                        ]"
                        @click="handleSelectSubItem(item, option)">
                        <div
                          :style="{ background: option.icon_bg_color }"
                          class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                          <component
                            :is="option.icon"
                            v-if="option.icon"
                            :class="['text-light-grey dark:text-common-grey']"
                            class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                            aria-hidden="true" />
                        </div>
                        <div>
                          {{ option.name }}
                        </div>
                      </button>
                    </div>
                  </MenuItems>
                </transition>
              </Menu>

              <div v-else class="flex items-center">
                <div :style="{ background: item.icon_bg_color }" class="flex items-center justify-center p-2 mr-4 text-center rounded-md">
                  <component
                    :is="item.icon"
                    v-if="item.icon"
                    :class="['text-light-grey dark:text-common-grey']"
                    class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration"
                    aria-hidden="true" />
                </div>

                <div>
                  {{ item.name }}
                  <span v-if="item.options?.length" class="absolute right-4">
                    <ChevronRight class="w-4 h-4" />
                  </span>
                </div>
              </div>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { ArrowDownUp, Timer, Split, Repeat2, Funnel, ChevronRight, Search } from "lucide-vue-next"
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import PlaybookTriggerIcon from "@/components/shared/icons/PlaybookGoalIcon.vue"
import PlaybookActionIcon from "@/components/shared/icons/PlaybookActionIcon.vue"
import PlaybookCircleSplitIcon from "@/components/shared/icons/PlaybookCircleSplitIcon.vue"
import PlaybookEndIcon from "@/components/shared/icons/PlaybookEndIcon.vue"
import PlaybookAddExtractorIcon from "@/components/shared/icons/PlaybookAddExtractorIcon.vue"
import TextInput from "@/components/shared/TextInput.vue"
import AIIcon from "@/components/shared/icons/AIIcon.vue"
import { DATA_TYPES_FLAT } from "@/store/constants/data_types.js"

export default {
  components: {
    TextInput,
    Search,
    Funnel,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    PlaybookTriggerIcon,
    PlaybookActionIcon,
    PlaybookCircleSplitIcon,
    Timer,
    Split,
    Repeat2,
    PlaybookEndIcon,
    ArrowDownUp,
    PlaybookAddExtractorIcon,
    ChevronRight,
    AIIcon
  },
  props: { position: null, data: null, elements: null, id: null, mainNode: null },
  emits: ["selectItem"],
  data() {
    return { search_term: "" }
  },
  computed: {
    items_filtered() {
      let split_after_switch = false

      if (this.data?.type == "split") {
        const element_connected_to_split = this.elements.find((el) => el.target == this.id)?.sourceNode
        if (element_connected_to_split?.data?.type == "switch") {
          split_after_switch = true
        }
      }

      if (this.data?.type == "switch" || split_after_switch) {
        return [{ name: this.$t("Add Condition"), value: "condition" }]
      }

      if (this.data?.type == "for" || this.data.node_in_loop) {
        return this.all_items.filter((item) => item.value == "action")
      }

      if (this.mainNode || this.data?.type == "branch") {
        return this.all_items.filter((item) => item.value == "trigger" || item.value == "wait")
      }
      if (this.data?.type == "parallel") {
        return this.all_items.filter((item) => item.value !== "switch" && item.value !== "end_branch" && item.value !== "parallel")
      }

      // if (this.data?.type !== "trigger" && (this.position == "r" || this.position == "l")) {
      //   return this.all_items.filter((item) => item.value !== "trigger")
      // }

      if (this.position == "r" || this.position == "l") {
        return this.all_items
      }
      return this.all_items
    },
    all_items() {
      return [
        {
          name: this.$t("Add Trigger"),
          node_type: "activity",
          value: "trigger",
          icon: "PlaybookTriggerIcon",
          icon_bg_color: "#71F9A715",
          options: [
            {
              value: "plan",
              name: this.$t("Plan"),
              data_type: DATA_TYPES_FLAT.Json,
              object_type: "plan"
            },
            {
              value: "goal",
              name: this.$t("Goal"),
              data_type: DATA_TYPES_FLAT.Json,
              object_type: "goal"
            },
            {
              value: "task",
              name: this.$t("Task"),
              data_type: DATA_TYPES_FLAT.Json,
              object_type: "task"
            },
            {
              value: "interaction",
              name: this.$t("Interaction"),
              data_type: DATA_TYPES_FLAT.Json,
              object_type: "interaction"
            },
            {
              value: "milestone",
              name: this.$t("Milestone"),
              data_type: DATA_TYPES_FLAT.Json,
              object_type: "milestone"
            },
            {
              value: "record",
              name: this.$t("Record"),
              data_type: DATA_TYPES_FLAT.Json,
              object_type: null // determined by the Trigger form
            }
          ]
        },
        {
          name: this.$t("Add Action"),
          node_type: "activity",
          value: "action",
          icon_bg_color: "#B171F915",
          icon: "PlaybookActionIcon",
          options: [
            {
              value: "change_metric",
              name: this.$t("Update Metric")
            },
            {
              value: "update_plan",
              name: this.$t("Update Plan")
            },
            {
              value: "update_goal",
              name: this.$t("Update Goal")
            },
            {
              value: "update_task",
              name: this.$t("Update Task")
            },
            {
              value: "update_interaction",
              name: this.$t("Update Interaction")
            },
            {
              value: "update_milestone",
              name: this.$t("Update Milestone")
            },

            {
              value: "send_email",
              name: this.$t("Send Email")
            },
            {
              value: "send_slack",
              name: this.$t("Send Slack")
            },
            {
              value: "notify",
              name: this.$t("Notify")
            },
            {
              value: "create_plan_from_template",
              name: this.$t("Create Plan")
            },
            {
              value: "create_goal_from_template",
              name: this.$t("Create Goal")
            },
            {
              value: "create_task",
              name: this.$t("Create Task")
            },
            {
              value: "create_interaction",
              name: this.$t("Create Interaction")
            }
          ]
        },
        {
          name: this.$t("Add Filter"),
          node_type: "activity",
          value: "action",
          icon: "Funnel",
          icon_bg_color: "#B171F915",
          icon_color: "#B171F9",
          options: [
            {
              value: "filter_records",
              name: this.$t("Record Filter"),
              data_type: DATA_TYPES_FLAT.List,
              object_type: null // company,contact,... determined by the Filter
            },
            {
              value: "filter_activities",
              name: this.$t("Activity Filter"),
              data_type: DATA_TYPES_FLAT.List,
              object_type: null // task,interaction ... determined by the Filter
            }
          ]
        },
        {
          name: this.$t("For Loop"),
          node_type: "activity",
          value: "for",
          icon_bg_color: "#35657815",
          icon: "Repeat2"
        },
        {
          name: this.$t("Parallel Execution"),
          node_type: "activity",
          value: "parallel",
          icon_bg_color: "#FF1BF615",
          icon: "Split"
        },
        {
          name: this.$t("Add Timer"),
          node_type: "activity",
          value: "wait",
          icon_bg_color: "#59BEE515",
          icon: "Timer"
        },
        {
          name: this.$t("Switch"),
          node_type: "activity",
          value: "switch",
          icon_bg_color: "#FFBE1515",
          icon: "ArrowDownUp"
        },
        {
          name: this.$t("Add End"),
          node_type: "activity",
          value: "end_branch",
          icon_bg_color: "#F9717115",
          icon: "PlaybookEndIcon",
          options: []
        }
      ]
    }
  },
  methods: {
    handleSelectItem(item) {
      if (!item.options?.length) {
        this.$emit("selectItem", this.$utils.clone(item))
      }
    },
    handleSelectSubItem(item, subItem) {
      this.$emit("selectItem", this.$utils.clone({ ...item, sub_item: subItem.value }))
    }
  }
}
</script>
